import classNames from 'clsx';
import React from 'react';

import type { MenuOption } from '../../DropdownMenu';

import styles from './Menu.scss';

export interface MenuProps {
  options?: MenuOption[];
  onSelect(option: MenuOption): void;
  menuClassName?: string;
}

const Menu = ({ options, onSelect, menuClassName }: MenuProps) => (
  <ul className={classNames(styles.menu, menuClassName)}>
    {options?.map((option, index) => (
      <li className={styles.option} key={index}>
        <button type="button" onClick={() => onSelect(option)} disabled={option.isActive === false}>
          {option.text}
        </button>
      </li>
    ))}
  </ul>
);

export default Menu;
